<template>
    <div class="cp303">
        <b-table
            :data="branch.giftCardProductNames"
            :hoverable="true">

            <template slot-scope="props">
                <b-table-column label="Produktnavn" width="90%">
                    {{ props.row.giftCardName }}
                </b-table-column>
                
                <b-table-column numeric>
                    <b-tooltip label="Rediger produktnavn">
                        <a class="button is-primary" @click="editProduct(props.row)">
                            <b-icon pack="fa" icon="edit"></b-icon>
                        </a>
                    </b-tooltip> 

                    <b-tooltip type="is-danger" label="Slett produkt" style="margin-left: 8px">
                        <a class="button is-danger" @click="deleteProduct(props.row)">
                            <b-icon pack="fa" icon="trash"></b-icon>
                        </a> 
                    </b-tooltip>
                </b-table-column>

            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                pack="fa"
                                icon="recycle"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Ingenting her, legg til nytt gavekortprodukt med knappen nedenfor.</p>
                    </div>
                </section>
            </template>

        </b-table>

        <a class="button is-primary" style="margin-top: 16px" @click="newProduct()">
            <b-icon pack="fa" icon="plus"></b-icon>
            <span>Nytt gavekortprodukt</span>
        </a>

    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: ['branch'],
    methods: {
        ...mapActions('products', ['saveGiftcardProduct', 'deleteGiftcardProduct']),
        editProduct (product) {
            this.promptProductName(product)
        },
        newProduct () {
            var product = {
                branchId: this.branch.id,
                id: 0,
                giftCardName: ''
            }

            this.promptProductName(product)
        },
        promptProductName (product) {
            this.$buefy.dialog.prompt({
                    message: `Angi produktnavn`,
                    confirmText: 'Lagre',
                    cancelText: 'Avbryt',
                    inputAttrs: {
                        placeholder: 'Produktets navn',
                        maxlength: 64,
                        value: product.giftCardName
                    },
                    onConfirm: (value) => this.saveProduct({...product, ...{giftCardName: value}})
            })
        },
        async saveProduct (product) {
            try {
                await this.saveGiftcardProduct(product)
                this.$buefy.toast.open({
                    message: 'Gavekortprodukt ble lagt til',
                    type: 'is-success',
                    position: 'is-bottom'
                })
            }
            catch (error) {
                this.$buefy.toast.open({
                    message: 'En feil oppstod under lagring av gavekortprodukt',
                    type: 'is-danger',
                    position: 'is-bottom'
                })
            }
        },
        deleteProduct (product) {
            this.$buefy.dialog.confirm({
                title: 'Slette gavekortprodukt',
                message: 'Er du sikker på at du ønsker å <b>slette</b> valgt gavekortprodukt?',
                confirmText: 'Slett',
                cancelText: 'Avbryt',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => this.deleteConfirmAction(product)
            })
        },
        async deleteConfirmAction (product) {
            try {
                await this.deleteGiftcardProduct(product)
                this.$buefy.toast.open({
                    message: 'Gavekortprodukt ble slettet',
                    type: 'is-success',
                    position: 'is-bottom'
                })
            }
            catch (error) {
                this.$buefy.toast.open({
                    message: 'En feil oppstod under sletting av gavekortprodukt',
                    type: 'is-danger',
                    position: 'is-bottom'
                })
            }
        }


    }
}
</script>
